import { isValidHexColor } from '@openx/utils/lib/isValidHexColor.ts';
import type { PyramidDiagramRow } from './types.ts';

export const defaultValueFormatter = (value: number): string => `${value}%`;

export const isValidRowValue = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value) && value > 0;

export const toChartValue = (value: unknown): number => (isValidRowValue(value) ? value : 0);

export const resolveColor = (color: string | undefined, fallback: string): string =>
  color && isValidHexColor(color) ? color : fallback;

export const hasRenderableData = (rows: PyramidDiagramRow[]): boolean =>
  rows.some(row => isValidRowValue(row.leftValue) || isValidRowValue(row.rightValue));
